import React from 'react';
import { getTheme, IStyle, ITheme, mergeStyles } from '@fluentui/react';
import { useCollectionKeys } from '../../../../framework/hooks/collection-keys';
import { IBlockquoteComponentModel } from '../../parser/blockquote';

const getStyleClass = (theme: ITheme) => {
  const style: IStyle = {
    margin: 0,
    padding: 0,
    border: 'none',
    marginBottom: '1em',
    paddingLeft: '1.5em',
    borderLeft: `6px solid ${theme.palette.neutralLight}`,
    color: theme.palette.neutralSecondary,

    '& p': {
      lineHeight: '1.5em',
      margin: 0,
      marginBottom: '1em',
    },

    '& p:last-child': {
      marginBottom: 0,
    },

    '& p > img': {
      display: 'block',
      border: 0,
      margin: '1em 0',
      padding: 0,
      maxWidth: '100%',
    },
  };

  return mergeStyles([ style ]);
}

export const MarkdownBlockquote: React.FunctionComponent<IBlockquoteComponentModel> = (props) => {
  const { paragraphs } = props;
  const pKeys = useCollectionKeys(paragraphs);
  const theme = getTheme();
  const styleClass = getStyleClass(theme);

  return (
    <blockquote className={styleClass}>
      {props.paragraphs.map((text, index) => <p key={pKeys[index]} dangerouslySetInnerHTML={{ __html: text }} />)}
    </blockquote>
  );
};
